// Added by Sejune Oh on 2020-03-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import {
  Dialog as MaterialUIDialog,
  DialogProps as MaterialUIDialogProps,
} from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface DialogBaseProps {}
export type DialogProps = MaterialUIDialogProps & DialogBaseProps

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const Dialog:FC<DialogProps> = ({...props}) => {
    return <MaterialUIDialog {...props} />
}
